import React, { useState, useEffect } from "react";

import { useIsAuthenticated } from "@azure/msal-react";
import { callMsGraph } from "./graph";
import { ReactComponent as ProfileIcon } from "./assets/profileicon.svg";
import { ReactComponent as LogoutIcon } from "./assets/logouticon.svg";
import { ReactComponent as DottedLineICon } from "./assets/dottedline.svg";

import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import Button from "@mui/material/Button";
import { ReactComponent as SiginIcon } from "./assets/siginicon.svg";
import { ReactComponent as LoginkeyIcon } from "./assets/loginkeyicon.svg";
import "./pagelayout.css";

import Home from "./Home";

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = (props: any) => {
    const isAuthenticated = useIsAuthenticated();
    const { instance } = useMsal();
    const [username, setusername] = useState("");
    const [Email, setEmail] = useState<any>("");
    const [logoutStatus, setLogoutStatus] = useState("");

    const handleLogout = () => {
        if (logoutStatus == "") {
            instance.logoutPopup({
                postLogoutRedirectUri: "/",
                mainWindowRedirectUri: "/",
            });
            setLogoutStatus("logged out");
        }
        sessionStorage.removeItem("sso");
        sessionStorage.removeItem('hasInfoModalShown');
    };

    const loadUserName = () => {
        try {
            let sso = sessionStorage.getItem("sso") || "";
            if (sso) {
                let sso_details = JSON.parse(sso);
                instance
                    .acquireTokenSilent({
                        ...loginRequest,
                        account: sso_details.account,
                    })
                    .then((response) => {
                        callMsGraph(response.accessToken).then((response) => {
                            setusername(response?.givenName);
                            setEmail(response?.mail);
                        });
                    });
            } else if (isAuthenticated) {
                handleLogout();
            }
        } catch (err) {
            console.log(err);
        }
    };
    const handleLogin = () => {
        instance
            .loginPopup(loginRequest)
            .then((res) => {
                sessionStorage.setItem("sso", JSON.stringify(res));
                loadUserName();
            })
            .catch((e) => {
                console.log(e);
            });
    };

    useEffect(() => {
        loadUserName();
    });

    return (
        <div>
            {isAuthenticated ? (
                <div>
                    <div className="header-section">
                        <div className="header-container">
                            <div className="banner-logo"></div>
                            <div className="profile-info">
                                <ProfileIcon style={{ marginRight: "6px" }} />{" "}
                                Welcome, {username}
                                <div
                                    className="logout-section"
                                    onClick={() => handleLogout()}
                                >
                                    <LogoutIcon
                                        style={{
                                            marginRight: "6px",
                                            marginLeft: "4em",
                                        }}
                                    />
                                    Sign Out
                                    <DottedLineICon
                                        style={{ marginLeft: "1em" }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {Email !== "" ? (
                        <div className="profileContent">
                            <Home Email={Email} referrName={username}>
                                {props.children}
                            </Home>
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            ) : (
                <div className="home-section">
                    <div className="login-background">
                        <div className="login-bg"></div>
                        <div className="login-section">
                            <div className="banner-logo-login"></div>
                            <div className="login-header">
                                <h3>
                                    <SiginIcon
                                        style={{
                                            position: "relative",
                                            top: "8px",
                                            right: "12px",
                                            color: "#073860",
                                        }}
                                    />
                                    Referral Portal
                                </h3>
                            </div>
                            <div className="login-btn">
                                <Button
                                    variant="contained"
                                    sx={{
                                        textTransform: "capitalize",
                                        marginRight: "16px",
                                        background: "#0067b8",
                                        width: "235px",
                                        fontWeight: "600",
                                    }}
                                    startIcon={
                                        <LoginkeyIcon
                                            style={{
                                                position: "relative",
                                                right: "5px",
                                                top: "1px",
                                            }}
                                        />
                                    }
                                    onClick={() => handleLogin()}
                                >
                                    Sign in With SSO
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
